/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Hero_H1_BeforeInputs */

const es_cap_hero_h1_before = /** @type {(inputs: Cap_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navega más. Y hazlo a `)
};

const gl_cap_hero_h1_before = /** @type {(inputs: Cap_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navega máis. E faino ao `)
};

const en_cap_hero_h1_before = /** @type {(inputs: Cap_Hero_H1_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sail more. And do it `)
};

/**
* | output |
* | --- |
* | "Sail more. And do it" |
*
* @param {Cap_Hero_H1_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_hero_h1_before = /** @type {((inputs?: Cap_Hero_H1_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Hero_H1_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_hero_h1_before(inputs)
	if (locale === "en") return en_cap_hero_h1_before(inputs)
	return es_cap_hero_h1_before(inputs)
});